'use client';

import ExpandMore from '@hc-frontend/core-icons/kit/expand-more';
import { addClassName } from '@hc-frontend/core-utils-format';

import { Link } from '../../atoms/link/link';
import {
  DrawerClose,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from '../../templates/drawer/drawer';
import type {
  HeaderProps,
  MultipleNavigationMenu,
  SingleNavigationMenu,
} from './header.types';

export function HeaderSidebar({
  menuIcon,
  menus,
  closeSidebarText,
  children: headerSidebarChildren,
}: React.PropsWithChildren<
  Pick<HeaderProps, 'menus'> & {
    closeSidebarText: React.ReactNode;
    menuIcon: JSX.Element;
  }
>) {
  return (
    <DrawerRoot>
      <DrawerTrigger asChild>
        <button aria-label="menu" type="button">
          {menuIcon}
        </button>
      </DrawerTrigger>
      <DrawerContent closeText={closeSidebarText} side="right">
        <div className="hc-typography--paragraph-md hc-stack-layout w-[440px] max-w-[100vw] overflow-y-auto p-24-24 [&_a:hover]:underline">
          {menus.map((menuItem) =>
            (menuItem as MultipleNavigationMenu).links ? (
              <details
                key={menuItem.key}
                className="[&_summary::-webkit-details-marker]:hidden [&_summary]:list-none"
              >
                <summary className="hc-icon-layout--right cursor-pointer font-bold [&_svg]:mx-[0]">
                  {menuItem.legend}
                  <ExpandMore />
                </summary>
                <div className="hc-stack-layout--small py-8-12">
                  {(menuItem as MultipleNavigationMenu).links.map(
                    ({ children, key: linkKey, className, ...linkProps }) => (
                      <DrawerClose asChild key={linkKey}>
                        <Link
                          {...linkProps}
                          className={addClassName(
                            'block',
                            'text-ellipsis',
                            '[text-wrap:nowrap]',
                            'overflow-hidden',
                            'w-[calc(100%)]',
                            'py-8-12',
                            'text-text-950',
                            className,
                          )}
                        >
                          {children}
                        </Link>
                      </DrawerClose>
                    ),
                  )}
                </div>
              </details>
            ) : (
              <DrawerClose asChild key={menuItem.key}>
                <Link
                  className="font-bold text-text-950"
                  key={menuItem.key}
                  {...(menuItem as SingleNavigationMenu).link}
                >
                  {menuItem.legend}
                </Link>
              </DrawerClose>
            ),
          )}
          {headerSidebarChildren}
        </div>
      </DrawerContent>
    </DrawerRoot>
  );
}
